module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mv2-l mv0 pa3 br1 flex justify-between font-responsive br-pill",
    class: [_vm.bgColor, _vm.changeMargin && 'margin-fixed']
  }, [_c('div', {
    staticClass: "fw5 mid-gray",
    class: _vm.textColor
  }, [_vm._t("default")], 2), _vm._v(" "), (this.deleteable) ? _c('div', {
    staticClass: "f4 ml3 pointer mid-gray",
    class: _vm.textColor,
    on: {
      "click": this.emitClose
    }
  }, [_vm._v("\n    ✕\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-108e492d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = 1214
// module chunks = 0